import Avatar from 'Components/Atoms/Avatar/Avatar';
import TextField from 'Components/Atoms/Fields/TextField/TextField';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import Text from 'Components/Atoms/Text/Text';
import MultiSelectField from 'Components/Molecules/Fields/MultiSelectField/MultiSelectField';
import SelectField from 'Components/Molecules/Fields/SelectField/SelectField';
import AvatarGroup from 'Components/Molecules/Group/AvatarGroup/AvatarGroup';
import TagGroup from 'Components/Molecules/TagGroup/TagGroup';
import {connect} from 'react-redux';
import {InternalDatasets} from 'Services/helpers';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import DateHelper from 'Services/Utils/Date/DateHelper';
import {fetchBusinessUnitDataset} from 'Store/BusinessUnit/Actions';
import {getBusinessUnitDataset} from 'Store/BusinessUnit/Selectors';
import {getCandidateDataset} from 'Store/Candidate/Selectors';
import {fetchContactDataset} from 'Store/Contact/Actions';
import {getContactDataset} from 'Store/Contact/Selectors';
import {FieldType} from 'Store/FieldManagement/PropTypes';
import {getDatasetLabels} from 'Store/FieldManagement/Selectors';
import {StoreState} from 'Store/Reducers';
import {fetchUsersDataset} from 'Store/User/Actions';
import {getUserDataset} from 'Store/User/Selectors';
import {getVacancyDataset} from 'Store/Vacancy/Selectors';
import {formatLocality, formatStreet} from '../AddressField/AddressField';
import DropdownField from '../DropdownField/DropdownField';
import MultiSelectorField from '../MultiSelectorField/MultiSelectorField';
import ToggleField from '../ToggleField/ToggleField';
import React from 'react';
import HTMLField from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/HTMLField';

export const formatDate = (number: any) => number < 10 ? '0' + number : number;

const Field = ({
    isEdit = false,
    value,
    type,
    onChange,
    properties,

    datasetLabels,
    candidateDataset,
    vacancyDataset,
    businessUnitDatasetById,
    contactDatasetById,

    userDatasetById,

    ...props
}: FieldProps) => {
    if (!isEdit) {
        if (typeof value === 'undefined') {
            return <NoValue />;
        }

        if (type === FieldType.Text) {
            return <Text>{ value }</Text>;
        }

        if (type === FieldType.Toggle) {
            return <>
                {
                    value
                    ? 'Ja'
                    : 'Nee'
                }
            </>;
        }

        if (type === FieldType.Date) {
            return <>{ DateHelper.getDateFormat(value) }</>;
        }

        if (type === FieldType.Address) {
            return <>{formatStreet(value)}, {formatLocality(value)}, {value?.country}</>;
        }

        if (type === FieldType.MultiSelect) {
            if (!Array.isArray(value)) return <NoValue />;

            return <TagGroup collapse='small'>
                {
                    value?.length > 0
                    ? value?.map(i => {
                        const label = properties?.list?.find(j => j?.value === i)?.label;
                        return <Tag>
                            { label }
                        </Tag>
                        }
                    )
                    : <NoValue />
                }
            </TagGroup>;
        }

        if (type === FieldType.Dropdown) {
            if (!Array.isArray(value)) {
                return <NoValue />;
            }

            return <TagGroup collapse='small'>
                {
                    value?.length > 0
                    ? value?.map(i =>
                        <Tag>
                            { datasetLabels?.[i] ?? i?.toString() }
                        </Tag>
                    )
                    : <NoValue />
                }
            </TagGroup>;
        }

        if (type === FieldType.Multi_Selector) {
            if (!Array.isArray(value) || value?.length === 0) {
                return <NoValue />;
            }

            const isInternalDataset = properties?.dataset?.[0] <= 0;
            if (isInternalDataset) {
                const datasetKey = properties?.dataset?.[0]
                if (datasetKey === InternalDatasets.USERS) {
                    props.fetchUsersDataset();
                    return <AvatarGroup>
                        { value?.map(i =>
                            <Avatar src={userDatasetById?.[i]?.picture}>
                                { userDatasetById?.[i]?.name }
                            </Avatar>
                        ) }
                    </AvatarGroup>;
                }

                if (datasetKey === InternalDatasets.BUSINESS_UNITS) {
                    props.fetchBusinessUnitDataset();
                    return <TagGroup collapse='small'>
                        {
                            Object.keys(businessUnitDatasetById).length > 0 &&
                            value
                            ?.map(i =>
                                <Tag url={EntityHelper.getEntityRoute(datasetKey, i)}>
                                    { businessUnitDatasetById?.[i?.toString()] ?? 'Bedrijf niet gevonden' }
                                </Tag>
                            )
                        }
                    </TagGroup>;
                }

                if (datasetKey === InternalDatasets.CONTACT) {
                    props.fetchContactDataset();
                    return <TagGroup collapse='small'>
                        {
                            Object.keys(contactDatasetById).length > 0 &&
                            value
                            ?.map(i =>
                                <Tag url={EntityHelper.getEntityRoute(datasetKey, i)}>
                                    { contactDatasetById?.[i?.toString()] ?? 'Contactpersoon niet gevonden' }
                                </Tag>
                            )
                        }
                    </TagGroup>;
                }
    
                return <NoValue />;
            }

            return <TagGroup collapse='small'>
                {
                    value?.length > 0
                    ? value?.map(i =>
                        <Tag>
                            { datasetLabels?.[i] ?? i?.toString() }
                        </Tag>
                    )
                    : <NoValue />
                }
            </TagGroup>;
        }

        if (type === FieldType.HTML_Editor) {
            return <HTMLField
                isEdit={false}
                value={value}
                onChange={onChange}
                fieldProperties={properties}
            />;
        }

        return <NoValue />;
    }

    if (isEdit) {
        if (type === FieldType.Text) {
            return <TextField
                value={value}
                onChange={onChange}
                {...properties}
            />;
        }

        if (type === FieldType.Dropdown) {
            return <DropdownField
                isEdit={true}
                value={value}
                onChange={onChange}
                fieldProperties={{
                    ...properties,
                    // isInline: isInline,
                    // alignLeft: properties?.alignLeft || alignLeft,
                    dataset: properties
                }}
            />
        }

        if (type === FieldType.Toggle) {
            return <ToggleField
                isEdit={true}
                value={value}
                onChange={onChange}
            />;
        }

        if (type === FieldType.Select) {
            return <SelectField
                isEdit={true}
                value={value}
                onChange={onChange}
                fieldProperties={properties}
            />;
        }

        if (type === FieldType.MultiSelect) {
            return <MultiSelectField
                isEdit={true}
                value={value}
                onChange={onChange}
                fieldProperties={properties}
            />
        }

        if (type === FieldType.Multi_Selector) {
            return <MultiSelectorField
                isEdit={true}
                value={value}
                onChange={onChange}
                fieldProperties={{
                    ...properties,
                    alignLeft: properties?.alignLeft,
                    dataset: properties
                }}
            />
        }

        if (type === FieldType.HTML_Editor) {
            return <HTMLField
                isEdit={true}
                value={value}
                onChange={onChange}
                fieldProperties={properties}
            />
        }
    }

    return <NoValue />;
}

interface Props {
    isEdit?: boolean,
    value: any,
    onChange?: any,
    type: FieldType,
    properties?: any & {
        tagStyle: {
            transparent: boolean
        }
    }
}

const mapState = (state: StoreState, props: Props) => ({
    datasetLabels: getDatasetLabels(state),
    candidateDataset: getCandidateDataset(state),
    vacancyDataset: getVacancyDataset(state),
    businessUnitDatasetById: getBusinessUnitDataset(state),
    contactDatasetById: getContactDataset(state),

    userDatasetById: getUserDataset(state)
});

const mapDispatch = {
    fetchUsersDataset,
    fetchBusinessUnitDataset,
    fetchContactDataset    
};

type FieldProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Field);